<template>
  <b-row v-if="sessions !== false && sessions.length > 0">
    <b-col lg="6">
      <phishing-timeline
        id="timeline-module"
        :sessions="orderedSessions"
        :controls="false"
        :selectable="true"
        @select="select"
        :selected="session.surveyEntityId"
        shorten
        :title="$t('campaigns.title')"
      />
    </b-col>
    <b-col lg="6" v-if="usersLoaded">
      <b-card class="card-custom card-stretch" no-body>
        <b-tabs
          card
          pills
          lazy
          nav-class="nav-light-success nav-bold col"
          nav-wrapper-class="card-toolbar pt-4"
          align="left"
          content-class="card-body text-left"
          v-if="usersLoaded"
        >
          <template v-slot:tabs-start>
            <div class="card-title" style="min-width: 100%;">
              <h3 class="card-label">
                {{ session.campaign }}
                <div class="font-size-sm text-muted mt-2 text-left">
                  {{ session.campaignCategory }}
                </div>
              </h3>
            </div>
          </template>
          <b-tab no-body lazy title-item-class="my-3">
            <template v-slot:title>
              <span class="nav-icon">
                <i class="la la-dashboard"></i>
              </span>
              <span class="nav-text">
                {{ $t("menu.dashboard.title") }}
              </span>
            </template>
            <div class="timeline timeline-3">
              <div class="timeline-items">
                <b-row>
                  <b-col
                    lg="6"
                    v-for="dimension in session.dimensions"
                    :key="dimension.id"
                    class="mt-3"
                  >
                    <b-row>
                      <b-col
                        cols="12"
                        style="line-height: 1.2em;"
                        :class="
                          `chart-title font-weight-bold font-size-sm text-${dimension.class}`
                        "
                      >
                        {{
                          $t(
                            `tables.dimensionIds.dimension.${dimension.id}.TEAM.description`
                          )
                        }}
                      </b-col>
                    </b-row>
                    <apexchart
                      type="radialBar"
                      height="250"
                      :options="chartOptions(dimension)"
                      :series="[dimension.value]"
                    ></apexchart>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-tab>
          <b-tab no-body lazy title-item-class="my-3">
            <template v-slot:title>
              <span class="nav-icon">
                <i class="la la-users"></i>
              </span>
              <span class="nav-text">
                {{ $t("campaigns.tabs.employees") }}
              </span>
            </template>
            <div class="table-responsive">
              <table class="table table-borderless mb-0">
                <tbody>
                  <!--begin::Item-->
                  <tr
                    v-for="employee in sessionEmployees"
                    :key="employee.stakeholderId"
                    :set="(user = getUserData(employee.stakeholderId))"
                  >
                    <td class="w-40px align-middle pb-6 pl-0 pr-2">
                      <avatar
                        size="sm"
                        :showArchetype="false"
                        :avatar="user.avatar || '000-Empty.svg'"
                      />
                    </td>
                    <td
                      class="font-size-lg font-weight-bolder text-dark-75 align-middle pb-6 text-left"
                    >
                      {{ user.name }} {{ user.surname }}
                    </td>
                    <td
                      class="font-weight-bolder font-size-md text-dark-75 text-left align-middle pb-6"
                      :set="(level = getLevelByStakeholder(employee))"
                    >
                      <span
                        :class="
                          `label label-inline label-light-${level.class} font-weight-bolder p-4`
                        "
                        style="font-size: 1rem;"
                        >{{ $t(`campaigns.levels.${level.value}`) }}</span
                      >
                      <span
                        v-if="isReported(employee)"
                        class="label label-inline label-light-primary font-weight-bolder p-4 ml-2"
                        style="font-size: 1rem;"
                        >{{ $t(`campaigns.levels.1`) }}</span
                      >
                    </td>
                  </tr>
                  <!--end::Item-->
                </tbody>
              </table>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
    <b-col cols="6" v-else>
      <b-card class="card-custom card-stretch" no-body>
        <div class="card-body">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="250" height="200" viewBox="0 0 250 200" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><path id="c" fill-rule="evenodd" d="M28.132 59.494C30.77 59.98 33.5 60 33.5 60 48.136 60 60 48.136 60 33.5S48.136 7 33.5 7c-3.76 0-7.336.783-10.576 2.195A26.604 26.604 0 009.896 21.442 26.388 26.388 0 007 33.5a26.402 26.402 0 006.684 17.596"/><path id="a" fill-rule="evenodd" d="M65.146 72.768a6.097 6.097 0 018.622-8.622l11.086 11.086a6.097 6.097 0 01-8.622 8.622L65.146 72.768z"/><circle id="b" cx="33.5" cy="33.5" r="33.5"/><mask id="d" x="-87" y="-66" maskContentUnits="userSpaceOnUse" maskUnits="userSpaceOnUse"><path d="M-87-66h250v200H-87z"/><use fill="#fff" xlink:href="#a"/></mask></defs><path fill="#F3F7FF" fill-rule="evenodd" d="M176 135H93a7 7 0 110-14H54a7 7 0 110-14h40a7 7 0 100-14H69a7 7 0 110-14h40a7 7 0 110-14h98a7 7 0 110 14h-40a7 7 0 110 14h22a7 7 0 110 14h-10.174c-4.874 0-8.826 3.134-8.826 7s6 7 6 7a7 7 0 110 14zm38-35a7 7 0 11-14 0 7 7 0 0114 0z"/><g transform="translate(87 66)"><use fill="#F3F7FF" xlink:href="#b"/><use fill-opacity="0" stroke="#75A4FE" stroke-width="2.5" xlink:href="#b"/></g><g transform="translate(87 66)"><use fill="#FFF" xlink:href="#c"/><use fill-opacity="0" stroke="#75A4FE" stroke-linecap="round" stroke-width="2.5" xlink:href="#c"/></g><path fill="none" stroke="#75A4FE" stroke-linecap="round" stroke-width="2.5" d="M103.797 120.075a26.473 26.473 0 007.204 4.172"/><path fill="none" stroke="#A4C3FE" stroke-linecap="round" stroke-width="2.5" d="M121 81c-1.723 0-3.392.23-4.979.659C107.943 83.847 102 91.229 102 100"/><path fill="none" stroke="#75A4FE" stroke-width="2.5" d="M148 126l6 6"/><g transform="translate(87 66)"><use fill="#E8F0FE" xlink:href="#a"/><use fill-opacity="0" stroke="#75A4FE" stroke-width="5" mask="url(#d)" xlink:href="#a"/></g><path fill="none" stroke="#FFF" stroke-linecap="round" stroke-width="2.5" d="M158 133l11 11"/></svg>
          <h2 v-html="$t('campaigns.emptyDetail')" />
        </div>
      </b-card>
    </b-col>
  </b-row>
  <b-row class="mt-1" v-else>
    <b-col>
      <empty-card type="department.phishing" />
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import _ from "lodash";
import axios from "axios";

import {
  getStakeholderCampaigns,
  getEntityProfile,
  getSubcampaigns
} from "@/api/controller/campaigns.api";
import { getUsers } from "@/api/controller/stakeholders.api";
import { extractValueFromProfile } from "@/utils/helpers";

import EmptyCard from "@/components/EmptyCard.component";
import PhishingTimeline from "@/components/dashboard/PhishingTimeline.component";
import Avatar from "@/components/profile/Avatar.component.vue";

export default {
  name: "Phishing",
  props: {
    stakeholderId: {
      type: Number,
      required: true
    },
    department: {
      type: Object,
      required: true
    },
    users: {
      type: Number,
      required: true
    },
    interactions: {
      type: Array,
      required: false
    }
  },
  components: {
    EmptyCard,
    PhishingTimeline,
    Avatar
  },
  data() {
    return {
      phishing: {},
      session: false,
      sessions: [],
      profile: {},
      phishingTypes: [],
      employees: [],
      sessionEmployees: [],
      usersProfiles: {},
      loaded: false,
      usersLoaded: false
    };
  },
  computed: {
    ...mapGetters("Constants", ["getConstant"]),
    activeDimensions() {
      return _.filter(
        this.session.dimensions,
        dim => dim.value === true || dim.value === 1
      );
    },
    orderedSessions() {
      return _.orderBy(
        this.sessions,
        [
          o => {
            return moment(o.userStartDate).format("x");
          }
        ],
        ["desc"]
      );
    }
  },
  methods: {
    select(selection) {
      const stakeholderId = localStorage.getItem("managedCompanyId");

      this.loaded = false;
      this.usersLoaded = false;
      this.usersProfiles = {};
      this.session = _.clone(selection);
      var cyberProfile = {
        groupDimensions: [this.getConstant("DIMENSION_GROUP_PHISHING")],
        surveyEntities: [this.session.surveyEntityId],
        filterDate: "NO"
      };
      axios
        .all([
          getEntityProfile(
            stakeholderId,
            this.session.campaignId,
            cyberProfile
          ),
          getSubcampaigns(stakeholderId, this.session.campaignId),
          getUsers("departments", this.stakeholderId, {
            avatar: true
          })
        ])
        .then(
          axios.spread((profileResp, subcampaignsResp, usersResp) => {
            this.employees = usersResp.data.records;
            var dimensions = [
              {
                name: "DIMENSION_ELEMENT_PHISHING_EMAIL_SENT",
                class: "success",
                color: "#1BC5BD",
                icon: "sending.svg"
              },
              {
                name: "DIMENSION_ELEMENT_PHISHING_EMAIL_OPENED",
                class: "info",
                color: "#8950FC",
                icon: "mail-opened.svg"
              },
              {
                name: "DIMENSION_ELEMENT_PHISHING_CLICKED_LINK",
                class: "warning",
                color: "#FFA800",
                icon: "cursor.svg"
              },
              {
                name: "DIMENSION_ELEMENT_PHISHING_SUBMITTED_DATA",
                class: "danger",
                color: "#F64E60",
                icon: "write.svg"
              }
            ];
            this.session.dimensions = [];
            var base = extractValueFromProfile(
              profileResp.data.records,
              "DIMENSION_GROUP_PHISHING",
              "SURVEY_KYMATIO_PHISHING",
              "dimensionValue",
              false,
              "DIMENSION_ELEMENT_PHISHING_EMAIL_SENT",
              this.session.surveyEntityId
            );
            if (base === false) base = 0;
            _.each(dimensions, dimension => {
              var rawValue = extractValueFromProfile(
                profileResp.data.records,
                "DIMENSION_GROUP_PHISHING",
                this.session.surveyTypeId,
                "dimensionValue",
                false,
                dimension.name,
                this.session.surveyEntityId
              );
              if (dimension.name === "DIMENSION_ELEMENT_PHISHING_EMAIL_SENT")
                base = rawValue;
              var value = rawValue;
              if (value === false) value = -1;
              else value = (value / base) * 100;
              this.session.dimensions.push({
                id: parseInt(this.getConstant(dimension.name)),
                name: dimension.name,
                class: dimension.class,
                color: dimension.color,
                icon: dimension.icon,
                value: value,
                rawValue: rawValue,
                base: base
              });
            });
            var status = moment().isAfter(this.session.userStartDate)
              ? this.session.userEndDate !== null &&
                moment().isAfter(this.session.userStartDate)
                ? "finished"
                : "progress"
              : "programmed";
            var statusClass =
              status === "finished"
                ? "success"
                : status === "progress"
                ? "info"
                : "warning";
            this.session.status = {
              id: status,
              class: statusClass,
              icon: "sending.svg"
            };
            this.session.employees = [];
            _.each(subcampaignsResp.data.records, subcampaign => {
              _.merge(this.session.employees, subcampaign.employees);
            });
            var userParams = {
              groupDimensions: [this.getConstant("DIMENSION_GROUP_PHISHING")],
              filterDate: "NO",
              subcampaigns: _.map(subcampaignsResp.data.records, "campaignId"),
              // surveyEntities: _.map(this.session.employees, "surveyEntityId"),
              // stakeholdersId: _.map(this.session.employees, "stakeholderId"),
              parentReference: "NO"
            };
            this.loaded = true;

            var pager = 0;
            var limit = 50;
            var requests = [];

            var surveyEntities = _.map(
              this.session.employees,
              "surveyEntityId"
            );
            var stakeholdersId = _.map(this.session.employees, "stakeholderId");

            while (pager * limit < _.size(this.session.employees)) {
              requests.push(
                getEntityProfile(
                  stakeholderId,
                  this.session.campaignId,
                  _.merge(userParams, {
                    surveyEntities: _.slice(
                      surveyEntities,
                      pager * limit,
                      (pager + 1) * limit
                    ),
                    stakeholdersId: _.slice(
                      stakeholdersId,
                      pager * limit,
                      (pager + 1) * limit
                    )
                  })
                )
              );
              pager++;
            }

            axios.all(requests).then(
              axios.spread((...responses) => {
                this.usersProfiles = {};
                _.each(responses, empProfilesResp => {
                  var employees = [];
                  _.each(this.employees, employee => {
                    var emp = _.find(
                      this.session.employees,
                      emp =>
                        parseInt(emp.stakeholderId) ===
                        parseInt(employee.stakeholderId)
                    );
                    if (emp) employees.push(emp);
                  });
                  this.sessionEmployees = employees;
                  this.usersProfiles = _.merge(
                    this.usersProfiles,
                    empProfilesResp.data.records
                  );
                });
                this.usersLoaded = true;
              })
            );
          })
        );
    },
    formattedDate(date) {
      return moment(date).format("ll");
    },
    getStatus(item) {
      if (moment(item.startDate).isAfter(moment())) {
        return "programmed";
      } else if (!item.endDate || moment(item.endDate).isAfter(moment())) {
        return "progress";
      } else {
        return "finished";
      }
    },
    getUserData(stakeholderId) {
      return _.find(
        this.employees,
        employee => parseInt(employee.stakeholderId) === parseInt(stakeholderId)
      );
    },
    isReported(employee) {
      return (
        extractValueFromProfile(
          Object.keys(this.usersProfiles).length > 1
            ? this.usersProfiles[employee.stakeholderId]
            : this.usersProfiles,
          "DIMENSION_GROUP_PHISHING",
          false,
          "dimensionValue",
          false,
          "DIMENSION_ELEMENT_PHISHING_EMAIL_REPORTED",
          employee.surveyEntityId
        ) === 1
      );
    },
    getLevelByStakeholder(employee) {
      var found = false;
      var index = 3;
      var dimensions = [
        "DIMENSION_ELEMENT_PHISHING_EMAIL_SENT",
        "DIMENSION_ELEMENT_PHISHING_EMAIL_OPENED",
        "DIMENSION_ELEMENT_PHISHING_CLICKED_LINK",
        "DIMENSION_ELEMENT_PHISHING_SUBMITTED_DATA"
      ];
      var value = 0;

      while (found === false && index >= 0) {
        var dimension = dimensions[index];
        index--;
        found =
          extractValueFromProfile(
            Object.keys(this.usersProfiles).length > 1
              ? this.usersProfiles[employee.stakeholderId]
              : this.usersProfiles,
            "DIMENSION_GROUP_PHISHING",
            false,
            "dimensionValue",
            false,
            dimension,
            employee.surveyEntityId
          ) === 1 || false;
      }

      if (found) value = index + 3;

      var cssClass = "disabled";
      if (value == 1) cssClass = "primary";
      else if (value == 2) cssClass = "success";
      else if (value == 3) cssClass = "info";
      else if (value == 4) cssClass = "warning";
      else if (value == 5) cssClass = "danger";

      return {
        value: value,
        class: cssClass
      };
    },
    chartOptions(dimension) {
      var self = this;
      return {
        chart: {
          height: 250,
          type: "radialBar"
        },
        colors: [dimension.color + "2b"],
        plotOptions: {
          radialBar: {
            hollow: {
              size: "60%"
            },
            track: {
              background: dimension.color + "2b"
            },
            dataLabels: {
              value: {
                formatter: val => {
                  if (
                    dimension.name === "DIMENSION_ELEMENT_PHISHING_EMAIL_SENT"
                  )
                    return dimension.rawValue || "?";
                  else if (val >= 0)
                    return dimension.rawValue + "/" + dimension.base;
                  else return "?";
                },
                fontSize: "2.3rem",
                offsetY: 10
              },
              name: {
                fontSize: "1.5rem",
                color: "#000",
                offsetY: -10
              }
            }
          }
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: true,
          theme: "light",
          y: {
            formatter: () => {
              return self.$n(
                dimension.rawValue /
                  (dimension.base !== false ? dimension.base : this.base),
                "percent"
              );
            }
          }
        },
        fill: {
          type: "solid",
          colors: [dimension.color]
        },
        stroke: {
          lineCap: "round"
        },
        labels: [
          this.$t(`tables.dimensionIds.dimension.${dimension.id}.DEFAULT.title`)
        ]
      };
    }
  },
  mounted() {
    const companyStakeholderId = localStorage.getItem("managedCompanyId");

    getStakeholderCampaigns(companyStakeholderId, this.stakeholderId, {
      filterDate: false
    }).then(campaignsResp => {
      this.sessions = campaignsResp.data.records;
    });
  }
};
</script>
